import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { formatDistanceToNow, isPast } from 'date-fns';
import { tr } from 'date-fns/locale';
import HandymanIcon from '@mui/icons-material/Handyman';
import GlassCard from '../../../ui/glass/components/GlassCard';

const ServicePreviewCard = ({ serviceRecord }) => {
    const [kalanSure, setKalanSure] = useState('');

    useEffect(() => {
        if (serviceRecord?.teslimTarihi) {
            const teslimTarihiDate = serviceRecord.teslimTarihi.toDate();
            if (isPast(teslimTarihiDate) && !['Teslime Hazır', 'Tamamlandı'].includes(serviceRecord.durum)) {
                setKalanSure("Gecikti");
                return;
            }
            setKalanSure(formatDistanceToNow(teslimTarihiDate, { addSuffix: true, locale: tr }));
        }
    }, [serviceRecord]);

    return (
        <GlassCard
            component={RouterLink}
            to={`/servis-kaydi/${serviceRecord.id}`}
            sx={{
                p: 1.5,
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'transform 0.2s',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    backgroundColor: 'rgba(255,255,255,0.1)'
                }
            }}
        >
            <Box sx={{
                width: 60,
                height: 45,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 122, 255, 0.1)',
                borderRadius: 2,
                p: 0.5
            }}>
                <HandymanIcon color="primary" />
            </Box>
            <Box>
                <Typography variant="body2" fontWeight="bold">
                    {serviceRecord.cihazSeriNumarasi}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {serviceRecord.musteriAdSoyad}
                </Typography>
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <Typography
                variant="caption"
                color={kalanSure === "Gecikti" ? "error" : "primary.main"}
                fontWeight="bold"
            >
                {kalanSure}
            </Typography>
        </GlassCard>
    );
};

export default ServicePreviewCard;
